module.exports = __webpack_public_path__ + "img/avatar2.3e4d39e8.png";